// constants/testIds/medard.js
export const MEDARD = {
    // Hero / lobby
    enterLobbyBtn: 'enter-lobby-btn',
    logoShield: 'logo-shield',
    // The splash's logo-reveal film (plays once, holds its final frame;
    // absent under prefers-reduced-motion / on video error → static blason).
    splashLogoReveal: 'splash-logo-reveal',
    // The mobile launch reveal — the signature MÉDARD title card, played once
    // per session on cold app open, then dissolved away (non-blocking).
    launchReveal: 'medard-launch-reveal',
    // App-root error boundary — a branded fallback (never a white screen) when
    // a runtime error escapes a view; the button reloads the app.
    appError: 'medard-app-error',
    appErrorReload: 'medard-app-error-reload',
    // Network-state ribbon — a calm « hors ligne » banner while the connection
    // is down, and a brief « reconnecté » confirmation when it returns.
    offlineBanner: 'medard-offline-banner',
    onlineBanner: 'medard-online-banner',
    // L'appareil va bien, c'est le serveur qui ne répond pas — une panne
    // distincte, donc une phrase distincte et un testid distinct.
    serverBanner: 'medard-server-banner',
    languageToggleFr: 'language-toggle-fr',
    languageToggleEn: 'language-toggle-en',
    visitorNameInput: 'visitor-name-input',
    visitorNameSkip: 'visitor-name-skip',

    // Owl / vitrine
    medardSculpture: 'medard-sculpture',
    medardSubtitle: 'medard-subtitle',
    medardStateBadge: 'medard-state-badge',

    // Voice + chat
    scanEyeButton: 'scan-eye-button',
    micButton: 'mic-button',
    textInput: 'medard-text-input',
    sendButton: 'medard-send-button',
    stopAudioButton: 'stop-audio-button',

    // Scan spotlight (first-visit nudge toward « L'Œil de Médard »)
    scanSpotlight: 'medard-scan-spotlight',
    scanSpotlightCta: 'medard-scan-spotlight-cta',
    scanSpotlightLater: 'medard-scan-spotlight-later',

    // Digital book
    digitalBook: 'digital-book',
    bookTitle: 'book-title',
    bookNarrative: 'book-narrative',
    // « La porte est close » — sourced opening status, above the narrative.
    bookStatus: 'book-status',
    // « Si vous y allez » — ce qu'on trouve SUR PLACE (canon `sur_place`),
    // au-dessus de tout le reste : un enfoui ou un disparu se lit AVANT
    // l'adresse, sinon l'invité a déjà noté où marcher.
    bookSurPlace: 'book-sur-place',
    bookSurPlaceRenvoi: 'book-sur-place-renvoi',
    bookFact: 'book-fact',
    // Long fact registers (> 3 rows) fold behind the « Détails » disclosure
    // so the chapter's colophon stays within reach (cœur-du-réacteur A3).
    bookFactsToggle: 'book-facts-toggle',
    bookSource: 'book-source',
    bookImage: 'book-image',
    // Navy answer plate: the verified figure is a capped thumbnail below the
    // opening paragraph; tapping it opens the full-screen lightbox (A3 —
    // fixes the old object-cover hero crop pushing the narrative down).
    bookImageZoom: 'book-image-zoom',
    bookImageLightbox: 'book-image-lightbox',
    bookImageLightboxClose: 'book-image-lightbox-close',

    // Monument gallery
    monumentGallery: 'monument-gallery',
    monumentCard: 'monument-card',  // suffix with `-${id}`

    // Suggestions / history
    suggestionChip: 'suggestion-chip',  // suffix with `-${idx}`
    // « Médard, montre-moi » — the tappable « Voir » card rendered under an
    // answer that carries show_entity; tapping opens that entity's fiche.
    showEntity: 'medard-show-entity',
    // « Questions ouvertes » (Mode Expert v1) — the Professeur's closing
    // section: the debates research has not settled, rendered ONLY when the
    // server ships book.open_questions (G-P2 anchored server-side).
    openQuestions: 'medard-open-questions',
    // LE SORT DE LA PROMESSE — la ligne discrète sous une réponse où Médard a
    // avoué son ignorance et promis un humain. `data-relay` porte l'état
    // honnête rendu par le serveur (recorded | pending | unavailable) ; la
    // porte de secours n'existe QUE hors du cas `recorded`.
    escalationNotice: 'medard-escalation-notice',
    escalationConcierge: 'medard-escalation-concierge',
    conversationDrawer: 'conversation-drawer',

    // Directions / map
    directionsPanel: 'directions-panel',
    directionsMap: 'directions-map',
    directionsDistance: 'directions-distance',
    directionsDuration: 'directions-duration',
};
